import "../../styles/ReviewsMenu.css";

const ReviewsMenu = () => {
  return (
    <div className="reviews-page fade-in" aria-label="Reviews page">
      <div className="reviews-box">
        <h2>Reviews</h2>
        <p>This is the reviews page.</p>
      </div>
    </div>
  );
};

export default ReviewsMenu;
